module.exports = "<!--BASEMENT VALUES: {{basementValues}}-->\r\n<artbycoloring-canvas></artbycoloring-canvas>\r\n"